import client from './client';

/**
 * Credits API functions
 * Handles credit status and limit checking
 */
export const creditsAPI = {
  /**
   * Get current user's credit status
   * @param {string} userId - Optional user ID
   * @returns {Promise<Object>} Credit status object with daily/monthly credits
   */
  getCreditStatus: async (userId = null) => {
    // Get user_id from localStorage if not provided
    if (!userId) {
      const user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('current_user') || '{}');
      userId = user.id;
    }
    const url = userId ? `/credits/status?user_id=${userId}` : '/credits/status';
    const response = await client.get(url);
    return response.data;
  },
  
  /**
   * Check if user has reached credit limit
   * @param {string} userId - User ID
   * @returns {Promise<Object>} Credit limit check result
   */
  checkCreditLimit: async (userId) => {
    const response = await client.get(`/credits/check/${userId}`);
    return response.data;
  }
};
